import styled from 'styled-components';

export default styled.div`
  margin: 30px 0;
  display: flex;
  align-items: center;

  > span {
    > span {
      font-size: 133%;
    }
  }
`;
